module.exports = __webpack_public_path__ + "img/ferry-wheel.8bd3419c.jpg";